/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordErrors } from './evidence-record-errors';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordFile } from './evidence-record-file';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordInvoiceIssuer } from './evidence-record-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordUpdatedBy } from './evidence-record-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordUploadedBy } from './evidence-record-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { EvidenceRecordWarnings } from './evidence-record-warnings';

/**
 * 
 * @export
 * @interface EvidenceRecord
 */
export interface EvidenceRecord {
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'evidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'paymentType': EvidenceRecordPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'electronicMethod': EvidenceRecordElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'documentSize': EvidenceRecordDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof EvidenceRecord
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'legalValidity': EvidenceRecordLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecord
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecord
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecord
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {EvidenceRecordFile}
     * @memberof EvidenceRecord
     */
    'file': EvidenceRecordFile;
    /**
     * 
     * @type {EvidenceRecordInvoiceIssuer}
     * @memberof EvidenceRecord
     */
    'invoiceIssuer': EvidenceRecordInvoiceIssuer | null;
    /**
     * 
     * @type {EvidenceRecordErrors}
     * @memberof EvidenceRecord
     */
    'errors': EvidenceRecordErrors;
    /**
     * 
     * @type {EvidenceRecordWarnings}
     * @memberof EvidenceRecord
     */
    'warnings': EvidenceRecordWarnings;
    /**
     * 
     * @type {EvidenceRecordUpdatedBy}
     * @memberof EvidenceRecord
     */
    'updatedBy': EvidenceRecordUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'updatedAt': string;
    /**
     * 
     * @type {EvidenceRecordUploadedBy}
     * @memberof EvidenceRecord
     */
    'uploadedBy': EvidenceRecordUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecord
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EvidenceRecord
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof EvidenceRecord
     */
    'uploadedFrom': string;
}

export const EvidenceRecordPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type EvidenceRecordPaymentTypeEnum = typeof EvidenceRecordPaymentTypeEnum[keyof typeof EvidenceRecordPaymentTypeEnum];
export const EvidenceRecordElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordElectronicMethodEnum = typeof EvidenceRecordElectronicMethodEnum[keyof typeof EvidenceRecordElectronicMethodEnum];
export const EvidenceRecordDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type EvidenceRecordDocumentSizeEnum = typeof EvidenceRecordDocumentSizeEnum[keyof typeof EvidenceRecordDocumentSizeEnum];
export const EvidenceRecordLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type EvidenceRecordLegalValidityEnum = typeof EvidenceRecordLegalValidityEnum[keyof typeof EvidenceRecordLegalValidityEnum];


